module.exports = __webpack_public_path__ + "7d2c648ea12bb36f653a0207876d9c94.png";